import type { FeatureFlag } from '@pflegenavi/shared/api';
import { FeatureFlagStatus } from '@pflegenavi/shared/api';
import {
  useGetTenantFeatureFlags,
  useUserProfileApi,
  useUserProfileWithContext,
} from '@pflegenavi/frontend/api-nursing-home';
import { useScope } from '@pflegenavi/frontend/nursing-home-context';
import { useAuthenticationInternal } from '@pflegenavi/frontend/authentication';

export const useFeatureFlagBase = (
  featureFlag: FeatureFlag
): FeatureFlagStatus => {
  const api = useUserProfileApi(true);

  const { data: userProfile } = useUserProfileWithContext({
    enabled: api !== undefined,
    refetchOnWindowFocus: false,
  });
  const auth = useAuthenticationInternal();

  const { kind, selectedNursingHome } = useScope();
  const { data: tenantFeatureFlags } = useGetTenantFeatureFlags();

  if (api && userProfile?.featureFlags?.includes(featureFlag)) {
    return FeatureFlagStatus.Enabled;
  }

  if (auth.user?.attributes?.[`ff.${featureFlag}`]) {
    return FeatureFlagStatus.Enabled;
  }

  const scopedFlags =
    kind === 'nursing_home'
      ? selectedNursingHome?.featureFlags
      : tenantFeatureFlags?.data.feature_flags;

  if (scopedFlags?.includes(featureFlag)) {
    return FeatureFlagStatus.Enabled;
  }

  return FeatureFlagStatus.Disabled;
};
